module.exports = __webpack_public_path__ + "img/ban_04.c2389883.png";